import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { SentInvitation } from '@theseus/shared-ui/orgs'

export function useOrgInvitations(orgId: string | undefined) {
  const { data: invitations = [], isLoading } = useQuery({
    queryKey: ['org-invitations', orgId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('org_invitations')
        .select('id, email, status, expires_at, created_at')
        .eq('org_id', orgId!)
        .order('created_at', { ascending: false })

      if (error) {
        console.error('Failed to fetch org invitations:', error)
        throw error
      }

      return (data ?? []).map((inv): SentInvitation => ({
        id: inv.id,
        email: inv.email,
        status: inv.status as SentInvitation['status'],
        expiresAt: inv.expires_at,
        createdAt: inv.created_at,
      }))
    },
    enabled: !!orgId,
  })

  return { invitations, loading: isLoading }
}
